import { buildApiUrl } from "../../services/apiConfig";

class responsibleService {
  constructor() {
    this.API_HOST = process.env.REACT_APP_API_URL;
    this.baseUrl = buildApiUrl('AUDIT');
    this.sumAuditBaseUrl = buildApiUrl('SUM_AUDIT');
  }

  async apiCall(endpoint, data) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`API Error (${endpoint}):`, error);
      throw error;
    }
  };

  // Get summary metrics for the dashboard
  async getSummaryMetrics(dateFilter, searchTerm = '', searchField = 'all') {
    const data = {
      dateFilter,
      searchTerm,
      searchField
    };
    return this.apiCall('/responsible-ai/summary-metrics', data);
  };

  // Get model usage data
  async getModelUsage(dateFilter, searchTerm = '', searchField = 'all') {
    const data = {
      dateFilter,
      searchTerm,
      searchField
    };
    return this.apiCall('/responsible-ai/model-usage', data);
  };

  // Get paginated prompts
  async getPaginatedPrompts(dateFilter, page, pageSize, searchTerm = '', searchField = 'all') {
    const data = {
      dateFilter,
      page,
      pageSize,
      searchTerm,
      searchField
    };
    return this.apiCall('/responsible-ai/prompts', data);
  };

  // Get total count of prompts
  async getPromptsCount(dateFilter, searchTerm = '', searchField = 'all') {
    const data = {
      dateFilter,
      searchTerm,
      searchField
    };
    return this.apiCall('/responsible-ai/prompts-count', data);
  };

  async getSummarizedAudit(runId) {
    try {
      const sumAuditUrl = buildApiUrl('SUM_AUDIT', `/${runId}/summary`);

      const response = await fetch(sumAuditUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`API Error (summarize_audit):`, error);
      throw error;
    }
  };
}

export default new responsibleService();